<div class="register-page">

  <div class="flex-row tw:pt-6">
    <div class="flex-column"></div>
    <div class="flex-column-main">
      <app-login-brand></app-login-brand>
    </div>
    <div class="flex-column"></div>
  </div>

  @if (model.username) {
    <div class="tw:w-full tw:px-[15px] tw:md:w-1/2 tw:md:ml-[25%]">
      <h2><label id="lblHeader" class="text-primary-colour">{{model.header}}</label></h2>
      <form [formGroup]="frmSignup">
        @if (model.type !== 'PR') {
          <div class="form-group" [ngClass]="{ 'has-error': submitted && f.username.errors }">
            <label for="username">Username</label>
            <input type="text" formControlName="username" readonly class="form-control" [(ngModel)]="model.username" />
            @if (submitted && f.username.errors) {
              <div class="help-block">
                @if (f.username.errors.required) {
                  <div>Username is required</div>
                }
              </div>
            }
          </div>
        }
        <div class="form-group">
          <label for="password" [ngClass]="frmSignup.controls['password'].invalid ? 'tw:text-danger' : ''">Password:</label>
          <input id="password" formControlName="password" type="password" class="form-control" [ngClass]="f.password.invalid ? 'is-invalid' : ''">
          <div class="tw:flex-1 tw:px-[15px]">
            <label [ngClass]="f.password.hasError('required') || f.password.hasError('minlength')  ? 'tw:text-danger' : 'tw:text-success'">
              @if (f.password.hasError('required') || f.password.hasError('minlength')) {
                <span>❌</span>
              }
              @if (!f.password.hasError('required') && !f.password.hasError('minlength')) {
                <span>✅</span>
              }
              Must be at least 8 characters!
            </label>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <label [ngClass]="f.password.hasError('required') || f.password.hasError('hasNumber')  ? 'tw:text-danger' : 'tw:text-success'">
              @if (f.password.hasError('required') || f.password.hasError('hasNumber')) {
                <span>❌</span>
              }
              @if (!f.password.hasError('required') && !f.password.hasError('hasNumber')) {
                <span>✅</span>
              }
              Must contain at least 1 number!
            </label>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <label [ngClass]="f.password.hasError('required') || f.password.hasError('hasCapitalCase')  ? 'tw:text-danger' : 'tw:text-success'">
              @if (f.password.hasError('required') || f.password.hasError('hasCapitalCase')) {
                <span>❌</span>
              }
              @if (!f.password.hasError('required') && !f.password.hasError('hasCapitalCase')) {
                <span>✅</span>
              }
              Must contain at least 1 in Capital Case!
            </label>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <label [ngClass]="f.password.hasError('required') || f.password.hasError('hasSmallCase')  ? 'tw:text-danger' : 'tw:text-success'">
              @if (f.password.hasError('required') || f.password.hasError('hasSmallCase')) {
                <span>❌</span>
              }
              @if (!f.password.hasError('required') && !f.password.hasError('hasSmallCase')) {
                <span>✅</span>
              }
              Must contain at least 1 Letter in Small Case!
            </label>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <label [ngClass]="f.password.hasError('required') || f.password.hasError('hasSpecialCharacters') ? 'tw:text-danger' : 'tw:text-success'">
              @if (f.password.hasError('required') || f.password.hasError('hasSpecialCharacters')) {
                <span>❌</span>
              }
              @if (!f.password.hasError('required') && !f.password.hasError('hasSpecialCharacters')) {
                <span>✅</span>
              }
              Must contain at least 1 Special Character!
            </label>
          </div>
          <div class="form-group">
            <label for="confirmPassword" [ngClass]="f.confirmPassword.invalid ? 'tw:text-danger' : ''">
              Confirm Password:
            </label>
            <input id="confirmPassword" formControlName="confirmPassword" type="password" class="form-control" [ngClass]="f.confirmPassword.invalid ? 'is-invalid' : ''">
            @if (f.confirmPassword.hasError('required')) {
              <label class="tw:text-danger"> Password is Required! </label>
            }
            @if (f.confirmPassword.hasError('NoPassswordMatch')) {
              <label class="tw:text-danger"> Password do not match </label>
            }
          </div>
          @if (showMfaTextField) {
            <div class="reg-flex-container">
              <div class="flex-column">
                <label for="mfaCode" [ngClass]="f.mfaCode.invalid ? 'tw:text-danger' : ''">Authentication Code:</label>
                <input id="mfaCode" formControlName="mfaCode" type="text" class="form-control" [ngClass]="f.mfaCode.invalid ? 'is-invalid' : ''">
              </div>
              <div class="flex-column div-content-start">
                <button class="btn btn-primary" (click)="generateMfa('resend')">Resend</button>
              </div>
            </div>
          }
          <div class="form-group">
            @if (showPasswordButton) {
              <button class="btn-outline-primary btn" (click)="submit()">{{model.buttonname}}</button>
            }
            @if (showContinueButton) {
              <button class="btn-outline-primary btn" (click)="generateMfa('activation')">Continue</button>
            }
          </div>
        </div>
      </form>
    </div>
  }
  @if (enableBtnResend) {
    <div class="flex-column">
      <button class="btn-outline-primary btn" (click)="resendCode()">Resend activation code</button>
    </div>
  }

</div>
